<template>
    <div id="workOrderList">
        <div class="search">
            <div class="belongType" @click="popupVisible = true">
                {{belongTypeList[listQuery.belongType-1]||"全部工单"}}
                <i class="iconfont iconxiala"></i>
            </div>
            <div class="searchbar">
                <i class="iconfont iconSearch left"></i>
                <form action="javascript:return true;">
                    <input v-model="listQuery.keyInfo" placeholder="请输入客户姓名/手机号/地址搜索" type="search" @keypress="searchBtn" maxlength="11" />
                </form>
                <i v-if="listQuery.keyInfo" @click="resetQuery" class="iconfont iconclose right"></i>
            </div>
        </div>
        <div class="status">
            <div class="num">
                <div :class="{'checked':!listQuery.status}" @click="changeStatus('')">全部{{statusObj.allNum}}</div>
                <div :class="{'checked':listQuery.status==1}" @click="changeStatus(1)">待指派{{statusObj.dzpNum}}</div>
                <div :class="{'checked':listQuery.status==2}" @click="changeStatus(2)">待接单{{statusObj.djdNum}}</div>
                <div :class="{'checked':listQuery.status==3}" @click="changeStatus(3)">待处理{{statusObj.dclNum}}</div>
                <div :class="{'checked':listQuery.status==4}" @click="changeStatus(4)">处理中{{statusObj.clzNum}}</div>
                <div :class="{'checked':listQuery.status==5}" @click="changeStatus(5)">已完成{{statusObj.ywcNum}}</div>
                <div :class="{'checked':listQuery.status==6}" @click="changeStatus(6)">已关闭{{statusObj.ygbNum}}</div>
                <!-- <div style="width:1.2rem;"></div> -->
            </div>
            <!-- <div class="filterBtn" @click="filterVisible = true">
                <van-icon name="filter-o" />筛选
            </div> -->
        </div>
        <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" @load="getList">
            <div class="body">
                <div class="card" v-for="(item,index) in list" :key="index" @click="$router.push({path:'/workOrderDetail',query:{id:item.id}})">
                    <p>
                        <span class="title">{{item.type}}</span>
                        <span class="theme-color">{{workOrderStatusList[item.status-1]}}</span>
                    </p>
                     <p>
                        <span>客户类型：{{item.customerType|| '-'}}</span>
                    </p>
                    <p>
                        <span>客户：{{item.customerName}}</span>
                    </p>
                    <p>
                        <span>地址：{{item.address}}</span>
                    </p>
                    <p>
                        <span>负责人：{{item.principal || '暂无'}}</span>
                    </p>
                    <p>
                        <span>创建时间：{{item.createDate || '暂无'}}</span>
                    </p>
                    <p v-if="item.status != 1&&item.status != 6">
                        <span>处理时长：<span v-if="item.handleDays">{{item.handleDays}}天</span><span>{{item.handleHours}}</span>时</span>
                    </p>
                </div>
            </div>
        </van-list>
        <div style="height:1.2rem"></div>
        <div class="btn">
            <van-button v-if="$store.state.buttonAuth.indexOf('crm_workOrderAdd')>-1" class="font1" type="primary" block @click="$router.push({path:'workOrderAdd'})">新增</van-button>
            <van-button class="font1" type="primary" block @click="filterVisible = true">筛选</van-button>
        </div>
        <van-popup v-model="popupVisible" position="bottom" class="popup">
            <van-picker show-toolbar :columns="[...['全部工单'],...belongTypeList]" value-key="desc" @cancel="popupVisible = false" @confirm="changeBelongType" />
        </van-popup>
        <van-popup v-model="filterVisible" position="top" :style="{ height: '50%' }">
            <div class="searchFilter">
                <div class="field">
                    <div class="searchT">排序方式</div>
                    <van-field readonly clickable name="createDateSortType" :value="createDateSortTypeList[listQuery.createDateSortType-1]" placeholder="请选择排序方式" @click="sortVisible = true;" />
                </div>
                <div class="field">
                    <div class="searchT">工单类型</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.type == ''}" @click="listQuery.type = ''">全部工单</div>
                        <div v-for="item in workOrderTypeList" :key="item.code" :class="{'active':listQuery.type == item.value}" @click="listQuery.type = item.code">{{item.name}}</div>
                    </div>
                </div>
                <div style="height:1.2rem;"></div>
                <div class="bottom">
                    <van-button class="font5" type="default" @click="resetSearch">重置</van-button>
                    <van-button class="font5" type="primary" @click="searchConfirm">确定</van-button>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="sortVisible" position="bottom" class="popup">
            <van-picker show-toolbar :columns="createDateSortTypeList" value-key="desc" @cancel="sortVisible = false" @confirm="(item,index)=>{listQuery.createDateSortType=index+1;sortVisible=false}" />
        </van-popup>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { requestWorkOrderList, requestWorkOrderStatus,requestServiceListOne } from "@/api";
import { accSub } from "@/utils";
export default {
    name: "workOrderList",
    data() {
        return {
            loading: false,
            finished: false,
            listQuery: {
                keyInfo: "",
                belongType: "",
                status: "",
                type: "",
                createDateSortType: "",
                pageNumber: 1,
                pageSize: 10,
            },
                      workOrderTypeList:[],
            list: [],
            filterVisible: false,
            popupVisible: false,
            sortVisible: false,
            statusObj: {
                clzNum: 0,
                dclNum: 0,
                djdNum: 0,
                dzpNum: 0,
                ygbNum: 0,
                ywcNum: 0,
            },
        };
    },
    computed: {
        ...mapState([
         
            "workOrderStatusList",
            "belongTypeList",
            "createDateSortTypeList",
        ]),
    },
    activated() {
        this.listQuery.pageNumber = 1;
        this.finished = false;
        this.list = [];
        this.getList();
        this.getWorkTypeListOne()
    },
    created() {},
    mounted() {},
    methods: {
        getList() {
            this.loading = true;
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中...",
            });
            requestWorkOrderList(this.listQuery)
                .then((res) => {
                    toast1.clear();
                    if (this.finished) return;
                    res.data.records.forEach((d) => {
                        d.showTitle = false;
                    });
                    this.list = [...this.list, ...res.data.records];
                    let prePage = accSub(res.data.pages, 1);
                    this.loading = false;
                    this.listQuery.pageNumber++;
                    if (
                        (res.data.pages == res.data.current &&
                            res.data.records.length ==
                                accSub(res.data.total, prePage * 10)) ||
                        !res.data.records.length
                    ) {
                        this.finished = true;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.finished = true;
                    toast1.clear();
                });
            let param = {
                keyInfo: this.listQuery.keyInfo,
                belongType: this.listQuery.belongType,
                type: this.listQuery.type,
                createDateSortType: this.listQuery.createDateSortType,
            };
            requestWorkOrderStatus(param).then((res) => {
                let allNum = 0;
                for (const key in res.data) {
                    allNum += res.data[key];
                }
                res.data.allNum = allNum;
                this.statusObj = res.data;
            });
        },
         getWorkTypeListOne(){
            requestServiceListOne()
            .then((res) => {
            // console.log(res.data)
                this.workOrderTypeList = res.data;
            
            })
            .catch((err) => {
            console.log(err);
            });
        },
        //点击搜索
        searchBtn() {
            if (event.keyCode == 13) {
                this.listQuery.pageNumber = 1;
                this.loading = true;
                this.finished = false;
                this.list = [];
                event.preventDefault(); //禁止默认事件（默认是换行）
                if (
                    this.listQuery.keyInfo == "" ||
                    this.listQuery.keyInfo == null
                ) {
                    return;
                } else {
                    this.getList();
                }
            }
        },
        changeBelongType(item, index) {
            this.listQuery.belongType = index || "";
            this.popupVisible = false;
            this.listQuery.pageNumber = 1;
            this.finished = false;
            this.list = [];
            this.getList();
        },
        changeStatus(status) {
            this.listQuery.status = status;
            this.listQuery.pageNumber = 1;
            this.finished = false;
            this.list = [];
            this.getList();
        },
        resetQuery() {
            this.listQuery = {
                keyInfo: "",
                belongType: "",
                status: "",
                type: "",
                createDateSortType: "",
                pageNumber: 1,
                pageSize: 10,
            };
            this.list = [];
            this.finished = false;
            this.filterVisible = false;
            this.getList();
        },
        searchConfirm() {
            this.listQuery.pageNumber = 1;
            this.filterVisible = false;
            this.finished = false;
            this.list = [];
            this.getList();
        },
        resetSearch() {
            this.listQuery.createDateSortType = "";
            this.listQuery.type = "";
        },
    },
    watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.body {
    // padding-top: 0.001rem;
    font-size: 0.35rem;
    margin-top: 0.3rem;
    .card {
        background: #fff;
        margin: 0.3rem;
        border-radius: 0.2rem;
        color: $color9;
        padding: 0.2rem 0;
        // margin: 0.2rem 0;
        p {
            text-align: left;
            display: flex;
            justify-content: space-between;
            padding: 0 0.4rem;
            line-height: 0.8rem;
            > span {
                height: 0.8rem;
            }
            .title {
                font-size: 0.35rem;
                font-weight: 600;
                height: auto;
                color: #000;
                // span {
                //     max-width: 4.5rem;
                //     vertical-align: top;
                //     overflow: hidden;
                //     display: inline-block;
                //     height: auto;
                //     text-overflow: ellipsis;
                // }
                // .ellipsis {
                //     white-space: nowrap;
                // }
            }
            .big {
                font-size: 0.4rem;
            }
        }
    }
    > .card:first-child {
        margin-top: 0;
    }
    .theme-color {
        color: $theme-color;
    }
}
.van-list {
    margin-top: 2.3rem;
}
.search {
    padding: 0.3rem;
    display: flex;
    position: fixed;
    width: 100%;
    z-index: 99;
    background: #f5f5f5;
    top: 0;
    left: 0;
    .belongType {
        width: 2rem;
        padding: 0.2rem 0;
        // span {
        //   display: inline-block;
        //   width: 1.2rem;
        //   overflow: hidden;
        //   text-overflow: ellipsis;
        //   vertical-align: text-bottom;
        //   white-space: nowrap;
        // }
        .iconxiala {
            font-size: 0.2rem;
        }
    }
    .searchbar {
        flex: 1;
        padding: 0.2rem;
        background-color: #fff;
        border-radius: 0.3rem;
        position: relative;
        .left {
            position: absolute;
            left: 0.3rem;
            top: 50%;
            transform: translateY(-50%);
        }
        .right {
            position: absolute;
            right: 0.3rem;
            top: 50%;
            transform: translateY(-50%);
        }
        input {
            background: none;
            outline: none;
            border: none;
            width: calc(100% - 1.5rem);
            text-align: center;
            height: 0.5rem;
            line-height: 0.5rem;
        }
    }
}
.status {
    position: fixed;
    width: 100%;
    z-index: 99;
    background: #f5f5f5;
    top: 1.5rem;
    left: 0;
    padding: 0 0.3rem;
    .num {
        width: 100%;
        overflow: auto;
        white-space: nowrap;
        &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
        }
        font-weight: 700;
        // border: 1px solid #aaaaaa;
        > div {
            padding: 0.1rem 0.24rem;
            background-color: #eaeaea;
            &:not(:last-child) {
                border-right: 1px solid #aaaaaa;
            }
            &:first-child {
                border-radius: 0.1rem 0 0 0.1rem;
            }
            &:last-child {
                border-radius: 0 0.1rem 0.1rem 0;
            }
            &.checked {
                background-color: $theme-color;
                color: #fff;
            }
            display: inline-block;
        }
    }
    .filterBtn {
        position: absolute;
        right: 0.3rem;
        top: 0;
        padding: 0.1rem 0.25rem;
        background-color: #eaeaea;
        z-index: 9;
        i {
            transform: translateY(0.02rem);
        }
    }
}
.searchFilter {
    background-color: #fff;
    z-index: 99;
    overflow: scroll;
    position: relative;
    height: 100%;
    // padding-top: 0.4rem;
    .field {
        padding: 0 0.7rem;
        .searchT {
            text-align: left;
            font-size: 0.35rem;
            font-weight: 600;
            color: #666666;
            margin: 0.4rem 0;
            // padding-left: 0.4rem;
        }
        /deep/.van-cell {
            border: 1px solid $border-color;
        }
        .flex {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            > div {
                width: 28%;
                height: 0.8rem;
                line-height: 0.8rem;
                border: 1px solid $border-color;
                margin-bottom: 0.3rem;
                &.active {
                    border: 1px solid $theme-color;
                    color: $theme-color;
                }
            }
        }
    }
    .bottom {
        position: absolute;
        bottom: 0;
        display: flex;
        width: 100%;
        /deep/.van-button--primary {
            margin-left: -1px;
            border: none;
            border-radius: 0;
        }
        .font5 {
            width: 51%;
        }
    }
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
    .font4 {
        width: 2.4rem;
    }
    .font3 {
        width: 1.8rem;
    }
    .font5 {
        width: 51%;
    }
    .font1 {
        width: 100%;
        margin-left: 0;
    }
}
</style>
